import { GridColDef } from '@material-ui/data-grid';

export interface TituloRow {
  id: string;
  cod_loja: number;
  num_docto: string | number;
  nome_pessoa: string;
  des_finalizadora: string;
  val_parcela: number | string;
  val_juros: number | string;
  dta_entrada: string | number | Date;
  dta_vencimento: string | number | Date;
  transferir?: boolean;
}

const BASE_CELL = 'super-app-theme--cell';
const BASE_HEADER = 'super-app-theme--header';

const base = {
  cellClassName: BASE_CELL,
  headerClassName: BASE_HEADER,
} as const;

const leftLeft = { headerAlign: 'left' as const, align: 'left' as const };
const leftRight = { headerAlign: 'left' as const, align: 'right' as const };
const centerCenter = {
  headerAlign: 'center' as const,
  align: 'center' as const,
};

export const makeCol = (col: GridColDef): GridColDef => ({
  ...leftLeft,
  ...base,
  ...col,
});

export const textCol = (col: GridColDef): GridColDef =>
  makeCol({ minWidth: 160, flex: 1, ...col });

export const numCol = (col: GridColDef): GridColDef =>
  makeCol({ width: 100, ...leftRight, ...col });

export const dateCol = (col: GridColDef): GridColDef =>
  makeCol({ width: 130, ...centerCenter, ...col });

export const actionsCol = (col: GridColDef): GridColDef =>
  makeCol({
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    width: 130,
    ...centerCenter,
    cellClassName: `${BASE_CELL} actions-cell`,
    headerClassName: `${BASE_HEADER} actions-cell`,
    ...col,
  });
